import { Toaster } from "sonner";
import CardPage from "@/pages/CardPage";

function App() {
  return (
    <>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0c1526",
            color: "#f4f1ea",
            border: "1px solid rgba(201, 164, 92, 0.45)",
            fontFamily: "Jost, system-ui, sans-serif",
            letterSpacing: "0.08em",
            fontSize: "12px",
          },
        }}
      />
      <CardPage />
    </>
  );
}

export default App;
